import type { GameDef } from '../registry';
import { dropCodeDef } from './def';
import { mountDropCode } from './view';

export const dropCode: GameDef = { ...dropCodeDef, mount: mountDropCode };
